import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import Layout from "../../layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import { config, reportsAPI, projectMasterAPI } from "../../config";
import DataTable from "react-data-table-component";
import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import * as XLSX from "xlsx/xlsx.mjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { Link } from "react-router-dom";

function ProjectPaymentReport() {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  let tempRefs = useRef(false);
  const handlePageChange = (page) => {
    tempRefs.current = false;
    getProjectReport(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    tempRefs.current = false;
    getProjectReport(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  // const handleSort = (column, sortDirection) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     field = column.field;
  //     orderBy = sortDirection;
  //     setLoading(false);
  //   }, 100);
  // };

  const columns = useMemo(() => [
    {
      name: "Project Name",
      field: "id",
      sortable: true,
      selector: (row) => (row.project_name ? row.project_name : "-"),
      // center: true,
    },
    {
      name: "Payment with PO",
      field: "id",
      // sortable: true,
      selector: (row) =>
        row.payment_with_po ? calculateTotal(row.payment_with_po) : "-",
      center: true,
    },
    {
      name: "Payment with WO",
      field: "id",
      // sortable: true,
      center: true,
      selector: (row) =>
        row.payment_with_wo ? calculateTotal(row.payment_with_wo) : "-",
    },
    {
      name: "Payment without PO/WO",
      field: "id",
      // sortable: true,
      center: true,
      selector: (row) =>
        row.payment_without_po ? calculateTotal(row.payment_without_po) : "-",
    },

    {
      name: "Pending requested Amount",
      field: "id",
      // sortable: true,
      center: true,
      selector: (row) =>
        row.pending_requested_amount
          ? calculateTotal(row.pending_requested_amount)
          : "-",
    },
    {
      name: "Unpaid requested Amount",
      field: "id",
      // sortable: true,
      center: true,
      selector: (row) =>
        row.unpaid_requested_amount
          ? calculateTotal(row.unpaid_requested_amount)
          : "-",
    },
    // {
    //   name: "Worked Hours",
    //   field: "id",
    //   // sortable: true,
    //   selector: (row) => {
    //     const [hours, minutes, seconds] = row.hours_of_working.split(":");
    //     return (
    //       <Grid>
    //         <Typography>{`${hours} hours & ${minutes} minutes`}</Typography>
    //       </Grid>
    //     );
    //   },
    //   center: true,
    // },
    {
      name: "Approved Requested Amount",
      field: "id",
      // sortable: true,
      center: true,
      selector: (row) =>
        row.approved_requested_amount
          ? calculateTotal(row.approved_requested_amount)
          : "-",
    },
    {
      name: "Total Received Amount",
      field: "id",
      sortable: true,
      selector: (row) => (row.amount ? row.amount : "-"),
      center: true,
    },
  ]);

  const downloadExcel = () => {
    const data = {
      // intProjectID: projectId ? projectId : projectID,
      // intType: 6,

      intProjectID: projectId ? projectId : projectID,
      intLimit: rowsPerPage || 10,
      intOffset: rowsPerPage ? (currentPage - 1) * rowsPerPage : 0,
      intType: 5,
    };
    config.method = "POST";
    config.data = data;
    config.url = reportsAPI;

    axios(config)
      .then(function (response) {
        const newData = response.data["result"].map((row) => {
          row.payment_with_po = row.payment_with_po ? row.payment_with_po : "-";
          row.payment_with_wo = row.payment_with_wo ? row.payment_with_wo : "-";
          row.payment_without_po = row.payment_without_po
            ? row.payment_without_po
            : "-";
          row.approved_requested_amount = row.approved_requested_amount
            ? row.approved_requested_amount
            : "-";
          row.unpaid_requested_amount = row.unpaid_requested_amount
            ? row.unpaid_requested_amount
            : "-";
          row.pending_requested_amount = row.pending_requested_amount
            ? row.pending_requested_amount
            : "-";
          row.payment_with_po = row.payment_with_po ? row.payment_with_po : "-";

          return row;
        });

        console.log(newData);
        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "report");
        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `ImagiNET-project-payment-report-${moment().format("DD-MM-YYYY")}.xlsx`
        );
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const [projectPaymentReport, setProjectPaymentReport] = useState([]);

  const [totalCount, setTotalCount] = React.useState(0);

  const getProjectReport = (page, rowsPerPage) => {
    const data = {
      intProjectID: projectId ? projectId : projectID,
      intLimit: rowsPerPage || 10,
      intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
      intType: 5,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = reportsAPI;

    axios(config)
      .then(function (response) {
        setProjectPaymentReport(response.data.result);
        calculateTotal(response.data.result[0]);

        setTotalCount(response.data.totalCount);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  let tempRefs1 = useRef(false);

  useEffect(() => {
    if (tempRefs1.current === false) {
      getProjectReport(1, rowsPerPage);
      return () => {
        tempRefs1.current = true;
      };
    }
  }, []);

  const [projectID, setProjectID] = useState(0);
  const [ProjectNameList, setProjectNameList] = useState([]);
  let tempRefs2 = useRef(false);

  useEffect(() => {
    if (tempRefs2.current === false) {
      const data = {
        intType: 6,
      };
      console.log(data);
      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = projectMasterAPI;

      axios(config)
        .then(function (response) {
          setProjectNameList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs2.current = true;
      };
    }
  }, []);

  const calculateTotal = (data) => {
    if (data) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "INR",
      });

      const formattedAmount = formatter.format(data);
      return formattedAmount;
    }
  };
  return (
    <Layout>
      <Grid className="employee-form">
        <Grid
          container
          spacing={2}
          margin={`15px 0px`}
          padding={`10px 15px 0px 0px`}
        >
          <Grid item xs={12} lg={3} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Project
              </InputLabel>
              <Select
                labelId="Select Project"
                id="demo-simple-select"
                value={projectID}
                label="Maristal Status"
                onChange={(e) => {
                  setProjectID(e.target.value);
                }}
              >
                {ProjectNameList.map((row, index) => (
                  <MenuItem value={row.id} key={index}>
                    {row.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} lg={3} md={3}>
            <LoadingButton
              size="large"
              variant="contained"
              color="primary"
              onClick={() => {
                getProjectReport(1, rowsPerPage);
              }}
            >
              Search
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid textAlign="right" item xs={12} lg={6} md={6}>
          <Button className="btn-primary" onClick={downloadExcel}>
            Export to Excel
          </Button>
        </Grid>
        <Grid className="form_design">
          <Grid>
            <DataTable
              pagination
              paginationServer
              // fixedHeader
              fixedHeaderScrollHeight="550px"
              columns={columns}
              data={projectPaymentReport}
              progressPending={loading}
              paginationTotalRows={totalCount}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[1, 10, 25, 50, 100]} //you can remove it later, just to have more pages
              paginationPerPage={rowsPerPage}
              onChangePage={handlePageChange}
              // onSort={handleSort}
              onChangeRowsPerPage={handleRowsPerPageChange}
            />
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default ProjectPaymentReport;
